import mutationsTypes from '@/vuex/ui/mutations-types.js'
const types = {
  ...mutationsTypes
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/ui/actions-types.js